import { Component, ViewContainerRef, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html'
})
export class AppComponent {
	viewContainerRef: ViewContainerRef;
	constructor(viewContainerRef: ViewContainerRef) {
		this.viewContainerRef = viewContainerRef;
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts